/** YouTube's highest-resolution auto-generated poster for a video. */
export const youtubePoster = (videoId: string) => `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
